<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR NORMA' : 'NOVA NORMA'" titleIcon="fas fa-gavel">
            <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Tipo" prop="tipo" :rules="$requiredChange">
                            <el-select v-model="dados.tipo" style="width: 100%;">
                                <el-option v-for="t in tipos" :key="t" :value="t" :label="rotulo(t)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Esfera" prop="esfera" :rules="$requiredChange">
                            <el-select v-model="dados.esfera" style="width: 100%;">
                                <el-option v-for="e in esferas" :key="e" :value="e" :label="rotulo(e)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Número" prop="numero" :rules="$requiredBlur">
                            <el-input v-model="dados.numero" placeholder="9.394/96"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Data de publicação">
                            <el-date-picker v-model="dados.data_publicacao" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Ementa" prop="ementa" :rules="$requiredBlur">
                    <el-input v-model="dados.ementa" type="textarea" :rows="2" maxlength="500" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="Assuntos">
                    <el-select v-model="dados.assuntos" multiple filterable allow-create default-first-option
                        style="width: 100%;" placeholder="matricula, educacao_especial, calendario...">
                        <el-option v-for="a in assuntosSugeridos" :key="a" :value="a" :label="a"></el-option>
                    </el-select>
                    <small>Usados na busca. Digite e pressione Enter para criar um assunto novo.</small>
                </el-form-item>

                <el-form-item label="Link oficial">
                    <el-input v-model="dados.url" placeholder="https://..."></el-input>
                </el-form-item>

                <el-form-item label="Texto da norma">
                    <el-input v-model="dados.texto" type="textarea" :rows="8"></el-input>
                </el-form-item>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Vigência">
                            <el-switch v-model="dados.vigente" active-text="Vigente" inactive-text="Revogada"></el-switch>
                            <div><small>Norma revogada permanece no acervo e continua consultável.</small></div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Situação do registro">
                            <el-switch v-model="dados.situacao" active-text="Ativo" inactive-text="Inativo"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- O anexo exige o registro salvo: o arquivo é nomeado com o id da norma. -->
                <el-form-item v-if="modoEdicao" label="Anexo em PDF">
                    <el-upload
                        :action="urlAnexo"
                        :headers="cabecalhoUpload"
                        name="arquivo"
                        accept="application/pdf"
                        :limit="1"
                        :on-success="anexoEnviado"
                        :on-error="anexoFalhou">
                        <el-button size="small" icon="el-icon-upload2">ENVIAR PDF</el-button>
                        <div slot="tip" class="el-upload__tip">Somente PDF, até 20 MB.</div>
                    </el-upload>
                    <div v-if="dados.arquivo_path" class="u-mt-10">
                        <el-button type="text" icon="el-icon-document" @click="abrirArquivo">Ver anexo atual</el-button>
                    </div>
                </el-form-item>
                <el-alert v-else type="info" :closable="false" class="u-mb-15"
                    title="Salve a norma para poder anexar o PDF."></el-alert>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/legislacao"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — item 35. */
export default {
    data: () => ({
        // Preenchidos por `legislacao/initForm` — o backend é a fonte única dos domínios.
        tipos: [], esferas: [],
        assuntosSugeridos: ['matricula', 'educacao_especial', 'calendario', 'frequencia',
                            'avaliacao', 'transporte', 'merenda', 'pessoal'],
        dados: { tipo: '', esfera: '', numero: '', data_publicacao: '', ementa: '', texto: '',
                 url: '', assuntos: [], arquivo_path: '', vigente: true, situacao: true }
    }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id },
        urlAnexo () {
            return `${this.$store.state.config.baseUrlApi}/api/legislacao/anexar/${this.$route.params.id}`
        },
        /** O upload não passa pelo $axios, então o Bearer vai no header manualmente. */
        cabecalhoUpload () {
            return { Authorization: 'Bearer ' + this.$store.state.token }
        }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/legislacao/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            this.tipos = (r.data && r.data.tipos) ? r.data.tipos : []
            this.esferas = (r.data && r.data.esferas) ? r.data.esferas : []
        }).catch(e => this.$store.commit('throwException', e))

        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/legislacao/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/legislacao')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
                if (!Array.isArray(this.dados.assuntos)) this.dados.assuntos = []
            }).catch(e => this.$store.commit('throwException', e))
        }
    },
    methods: {
        rotulo (v) {
            return { lei: 'Lei', decreto: 'Decreto', portaria: 'Portaria', resolucao: 'Resolução',
                parecer: 'Parecer', convencao: 'Convenção', instrucao_normativa: 'Instrução Normativa',
                federal: 'Federal', estadual: 'Estadual', municipal: 'Municipal',
                internacional: 'Internacional' }[v] || v
        },
        abrirArquivo () {
            window.open(`${this.$store.state.config.baseUrlApi}/storage/${this.dados.arquivo_path}`, '_blank')
        },
        anexoEnviado (resposta) {
            if (resposta && resposta.erro) {
                window.eventBus.$emit('alert', { msg: this.textoErro(resposta.erro), type: 'warning' })
                return
            }
            this.dados.arquivo_path = resposta.arquivo_path
            window.eventBus.$emit('alert', { msg: 'Arquivo anexado.', type: 'success' })
        },
        anexoFalhou () {
            window.eventBus.$emit('alert', { msg: 'Não foi possível enviar o arquivo.', type: 'warning' })
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/legislacao/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/legislacao/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Norma salva.', type: 'success' })
                    this.$router.push('/admin/legislacao')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
